import React from 'react'
import PageHeader from '../components/PageHeader'
import PageContent from '../components/PageContent'
import Blog from '../components/Blog'
import { useSelector } from 'react-redux';

function AboutUsPage({ title }) {
  const store = useSelector((state) => state.auth.store);
  return (
    <div>
      <PageHeader title={title} />
      <PageContent elem={<Blog image={store.about_image} content2={store.about_page} />} />
    </div>
  )
}

export default AboutUsPage